import { valueLabelFor } from '~/components/AiSearchChips/DateRangeChip/DateRangeChip.utils';
export const lastBilledModeOf = (predicate)=>{
    if (predicate.exists === true) return 'ever';
    if (predicate.exists === false) return 'never';
    if (predicate.gte != null || predicate.lte != null || predicate.eq != null || predicate.neq != null) return 'range';
    return 'all';
};
export const lastBilledSummary = (predicate, texts)=>{
    switch(lastBilledModeOf(predicate)){
        case 'ever':
            return texts.everBilled;
        case 'never':
            return texts.neverBilled;
        case 'range':
            return valueLabelFor(predicate, texts.specificRange);
        default:
            return texts.allChip;
    }
};
